import React from "react";
import { useLocation } from "react-router-dom";
import LangToggle from "./LangToggle";
import { SunIcon, MoonIcon } from "./Icons";
import useTheme from "../useTheme";
import { useLang } from "../LangContext";
import "./PublicControls.css";

export default function PublicControls() {
  const { pathname } = useLocation();
  const [theme, toggleTheme] = useTheme();
  const { t } = useLang();

  // "/" is handled by DashboardTopbar (logged in) or AuthControls inside the card (logged out)
  if (pathname === "/") return null;

  return (
    <div className="public-controls">
      <LangToggle />
      <button
        type="button"
        className="theme-toggle"
        aria-label={theme === "dark" ? t.switchToLight : t.switchToDark}
        onClick={toggleTheme}
      >
        {theme === "dark" ? <SunIcon /> : <MoonIcon />}
      </button>
    </div>
  );
}
